import { Injectable } from "@angular/core";
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Actions } from "@ngrx/effects/src/actions";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";
import { Store, Action } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Event } from "@models/event";
import { FETCH_EVENTS, POPULATE_EVENTS } from "@reducers/events";

@Injectable()
export class EventsViewResolver implements Resolve<boolean> {

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const result =
      this.actions
        .ofType(POPULATE_EVENTS)
        .take(1)
        .map(() => true)

    this.store.dispatch({ type: FETCH_EVENTS })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/events-view.ts